export const IconHomeFilled = (props: { size?: number }) => {
  const { size = 24 } = props
  return (
    <svg xmlns='http://www.w3.org/2000/svg' height={size} viewBox='0 -960 960 960' width={size} fill='currentColor'>
      <path d='M135-216v-337q0-29 12.25-54.25T183-650l224-168q33-25 73-25t73 25l224 168q23.5 17.5 35.75 42.75T825-553v337q0 51-35 86t-86 35h-73q-24.5 0-42.5-18t-18-42.5v-197q0-24.5-18-42.5T510-413h-60q-24.5 0-42.5 18t-18 42.5v197q0 24.5-18 42.5T329-95h-73q-51 0-86-35t-35-86Z' />
    </svg>
  )
}
